//
// PLEASE PAY ATTENTION TO https://www.w3.org/WAI/WCAG21/Techniques/general/G65
//
import { sanitizeTitle } from "../../utils/customSanitize";
import styles from "./Breadcrumbs.module.scss";
import { ParentsType } from "../../wp/getParentPages";
import { getTitle } from "../../wp/getHeader";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { Post } from "@/wp/types/client";
import { CustomLink } from "../CustomLink";

export interface BreadcrumbProps {
  post: Post;
  breadcrumbPositon:
    | "is-justify-content-flex-start"
    | "is-justify-content-center"
    | "is-justify-content-flex-end";
  showOnMobile?: boolean;
  parents: ParentsType;
  extraClass?: string;
}

export const Breadcrumbs = ({
  post,
  breadcrumbPositon = "is-justify-content-flex-start",
  parents,
  showOnMobile,
  extraClass = "",
}: BreadcrumbProps) => {
  const title = getTitle({ post });

  const { getLabel } = useGlobalContext();

  return (
    <nav
      aria-label="Breadcrumbs"
      className={`${styles.breadcrumbs} ${!showOnMobile ? "is-hidden-mobile" : ""} ${extraClass}`}
    >
      <ul className={`${breadcrumbPositon}`}>
        <li>
          <CustomLink href="/" target={"_self"} className={` ${styles.item}`}>
            {getLabel("breadcrumb_root")}
          </CustomLink>
        </li>
        {parents
          .filter((p) => !p.isEmptyParentPage)
          .map((el, i) => {
            const removeStrongTitle = el.title
              .replace(/<strong>/g, "")
              .replace(/<\/strong>/g, "");
            return (
              <li key={i}>
                <CustomLink
                  href={el.url}
                  target="_self"
                  className={` ${styles.item}`}
                >
                  {removeStrongTitle}
                </CustomLink>
              </li>
            );
          })}
        <li aria-current="page">
          <span
            className={` ${styles.item}`}
            dangerouslySetInnerHTML={{
              __html: sanitizeTitle(title ?? ""),
            }}
          ></span>
        </li>
      </ul>
    </nav>
  );
};
